export default "__VITE_ASSET__DEJ5FJ23__"